export const config = {
  GA: "G-GLGM7YDP3H",
  defaultPasswordLength: 16,
};
